import { Empty, Spin } from 'antd';
import { isEmpty } from 'underscore';
import { ChartBox } from '../../../../ResultPanel/component/ChartBox';
import ErrorDisplay from '../../ErrorDisplay';
import styles from '../../Layout/AnalyticsLayout.module.scss';

interface ExtremeValuesChartProps {
  extremeValuesImage: string;
  extremeValuesLinks: string[];
  pointName: string;
  isLoading: boolean;
  error: string;
  isOfflineDataset: boolean;
}

export default function ExtremeValuesChart({
  extremeValuesImage,
  extremeValuesLinks,
  isLoading,
  error,
  isOfflineDataset,
}: ExtremeValuesChartProps) {
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: '400px',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (isOfflineDataset) {
    return <ErrorDisplay isOfflineDataset={isOfflineDataset} />;
  }

  return (
    <div className={styles.chartPointWrapper}>
      <ChartBox
        key="Extreme Values"
        title="Extreme Values"
        height={isLoading || !isEmpty(error) ? '50px' : 'auto'}
        plot={
          isLoading ? (
            <div className={styles.spinner}>
              <Spin size="large" />
            </div>
          ) : !isEmpty(error) && !error.includes('Cmems error') ? (
            <div>{error}</div>
          ) : extremeValuesImage ? (
            <img
              id="Analytics-ExtremeValues-Plot"
              style={{
                width: '80%',
                objectFit: 'scale-down',
                maxHeight: '65vh',
                display: 'block',
                margin: '0 auto',
              }}
              src={extremeValuesImage}
              alt="ExtremeValues"
            />
          ) : (
            <Empty
              description={
                error.includes('Cmems error') ? 'Layer not available' : 'No data available'
              }
            />
          )
        }
        dataset=""
        showDisclaimer={extremeValuesImage ? true : false}
        link={extremeValuesLinks}
      />
    </div>
  );
}
